import { Component } from '@angular/core';
import { ViewController, NavParams, NavController } from "ionic-angular";
import { Localization } from '../../app/app.localization';

@Component({
  selector: 'page-order-modal',
  templateUrl: 'order-modal.html',
})
export class OrderModalPage {
  shouldPropagate = false;
  total: number;
  constructor(public viewCtrl: ViewController,
    public navParams: NavParams,
    private _loc: Localization,
    public navCtrl: NavController
  ) {
    this.total = navParams.get('total');
  }

  close(data) {
    this.viewCtrl.dismiss(data);
  }
}



// WEBPACK FOOTER //
// ./src/pages/order-modal/order-modal.ts